import * as React from 'react'
import TextContainer from '../layout/TextContainer';


type Props = {
  className?: string
}

const TerminalDisclaimerSection: React.FC<Props> = ({ className = '' }) => {

  return (
    <div className={' ' + className}>
      <TextContainer>

        <h2 className="text-xl font-bold mb-2 text-gray-800">Disclaimer</h2>
        <p>
          LnRouter - Terminal Score Debugger is based on an attempt to reverse-engineer the score.
          We can not guarantee the accuracy / validity of the data. The data provided is best effort.
          Use at your own risk.
          </p>
      </TextContainer>
    </div>
  );
}

export default TerminalDisclaimerSection;

